import { createEnum } from '@luna/utils-ts';

export const COUNTRY = createEnum('AT', 'CZ', 'SK', 'RO', 'HR', 'HU', 'RS');
export type COUNTRY = createEnum<typeof COUNTRY>;
